import { render, staticRenderFns } from "./SGPFormCheckboxComponent.vue?vue&type=template&id=4904aa54"
import script from "./SGPFormCheckboxComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormCheckboxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports